import { render, staticRenderFns } from "./AuthStatusCpt.vue?vue&type=template&id=622cf57e&scoped=true&"
import script from "./AuthStatusCpt.vue?vue&type=script&lang=ts&"
export * from "./AuthStatusCpt.vue?vue&type=script&lang=ts&"
import style0 from "./AuthStatusCpt.vue?vue&type=style&index=0&id=622cf57e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "622cf57e",
  null
  
)

export default component.exports